import { useTranslation } from '@shared/core';

export const useFooterTranslations = () => {
  const { t } = useTranslation('yourRegistry');
  const { shipping, returns, termsAndPrivacy, support } = t('departmentFooter');

  return {
    shipping,
    returns,
    termsAndPrivacy,
    support,
  };
};
